/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowhellotitle3Inputs */

const en_aiflowhellotitle3 = /** @type {(inputs: Aiflowhellotitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's on?`)
};

const de_aiflowhellotitle3 = /** @type {(inputs: Aiflowhellotitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was steht an?`)
};

/**
* | output |
* | --- |
* | "What's on?" |
*
* @param {Aiflowhellotitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowhellotitle3 = /** @type {((inputs?: Aiflowhellotitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowhellotitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowhellotitle3(inputs)
	return de_aiflowhellotitle3(inputs)
});
export { aiflowhellotitle3 as "aiFlowHelloTitle" }